var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"height":"calc(100vh - 140px)"}},[_c(_vm.tag,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }